import React, { Component } from "react";
import { PhoneCall } from "react-feather";
import { Button } from "../../../common/Button/Button";

class HandleRequestDropdown extends Component {
	constructor(props) {
		super(props);
		this.state = {
			listOpen: false,
			headerTitle: this.props.title,
		};
	}

	componentDidUpdate() {
		const { listOpen } = this.state;
		setTimeout(() => {
			if (listOpen) {
				window.addEventListener("click", this.close);
			} else {
				window.removeEventListener("click", this.close);
			}
		}, 0);
	}

	componentWillUnmount() {
		window.removeEventListener("click", this.close);
	}

	close = (timeOut) => {
		this.setState({
			listOpen: false,
		});
	};

	toggleList() {
		this.setState((prevState) => ({
			listOpen: !prevState.listOpen,
		}));
	}

	render() {
		const { listOpen } = this.state;
		return (
			<>
				<Button
					className={`${this.props.bMovedToSPM ? "disable" : ""} ${
						this.props.disableConfirmAndSave
					}`}
					onClick={this.props.onUpdateServiceRequest}
				>
					Confirm and Save
				</Button>
			</>
			// <div className={`dd-wrapper
			// ${this.props.bMovedToSPM ? 'disabled' : ''}`}>
			//   <div className="dd-header" onClick={() => this.toggleList()}>
			//     <div className="dd-header-title">
			//       <PhoneCall color={this.props.color} />
			//     </div>
			//   </div>
			//   {listOpen && (
			//     <div className="dd-list status">
			//       <div className="cursor-pointer"
			//         onClick={this.props.onUpdateServiceRequest}>
			//         All Done
			//       </div>
			//     </div>
			//   )}
			// </div>
		);
	}
}

export default HandleRequestDropdown;
